import { onSubmitAdmin } from 'utils';
import { AdminRegisterOnSubmitFunction } from './createAdmin.type';

const adminCreateOnSubmit: AdminRegisterOnSubmitFunction = payload => {
  return onSubmitAdmin({ method: 'post', ...payload });
};

export default adminCreateOnSubmit;
